import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { delayedTask, destoryDelayedTask, delayedDescData, delayedDescDel } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import parameterPopup from "../../financial/backhaul/components/components/parameterPopup";
import addtask from "./components/addtask";
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "timedTasksRecord",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    parameterPopup: parameterPopup,
    addtask: addtask,
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      tableData: [],
      activeIndex: '0',
      tableDescData: [],
      paramsUpLoadData: {
        is_full: 2
      },
      currentPage: 1,
      pageSize: 10
    };
  },
  created: function created() {
    this.searchClick(1);
  },
  computed: {},
  methods: {
    handleSelect: function handleSelect(e) {
      this.activeIndex = e;

      if (e == "0") {
        this.searchClick(1);
      } else if (e == "1") {
        this.getTask();
      }
    },
    searchClick: function searchClick(e) {
      var _this = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      delayedTask(_objectSpread({}, this.paramsData)).then(function (res) {
        if (res.code == 200) {
          var data = res.data.data || [];
          data.forEach(function (item) {
            item.properties = item.command_data.properties;
          });
          _this.tableData = data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    getTask: function getTask() {
      var _this2 = this;

      delayedDescData().then(function (res) {
        if (res.code == 200) {
          _this2.currentPage = 1;
          _this2.PrimitiveData = res.data;
          _this2.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
          _this2.tableDescData = _this2.currentChangePage(_this2.pageSize, _this2.currentPage);
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(data) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                destoryDelayedTask({
                  score: data
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.searchClick(_this3.paramsData.page);

                    _this3.$message({
                      type: "success",
                      message: _this3.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleDescDelete: function handleDescDelete(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delayedDescDel({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this4.getTask();

                    _this4.$message({
                      type: "success",
                      message: _this4.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.tableDescData = this.currentChangePage(this.pageSize, currentPage);
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableDescData = this.currentChangePage(pageSize, this.currentPage);
    },
    currentChaneg: function currentChaneg(e) {
      this.paramsData.page = e;
      this.searchClick();
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    }
  }
};